import b2wPid from 'b2w-pid';

b2wPid();
